import { TaskDefinition } from '@/feature/execution-board'
import { useTaskProgress } from '@/feature/execution-board/api/useTaskProgress'
import { MapShape } from '@/feature/map'

import { useTaskAssetPosition } from '../../hooks/useTaskAssetPosition'
import { getLocationCoordinates } from '../TaskMapOverlay/getTaskMarkers'
import { resolveEnRouteTargetLocationId } from './TaskAssetEnRouteLine.utils'

const LINE_COLOR = '#E18336'

interface TaskAssetEnRouteLineProps {
  task: TaskDefinition
}

// Draws a straight dashed line from the task's assigned asset (its live telemetry position) to the
// stop it is currently travelling to — the `en_route_to` location, or the next remaining stop when
// the progress payload has no en-route target.
export const TaskAssetEnRouteLine = ({ task }: TaskAssetEnRouteLineProps) => {
  const { data: progress } = useTaskProgress(task.taskDefinition.id)
  const assetPosition = useTaskAssetPosition(task)

  const targetLocationId = resolveEnRouteTargetLocationId(progress)
  const targetLocation = targetLocationId
    ? task.taskDefinition.locations.find((location) => location.id === targetLocationId)
    : undefined
  const targetPosition = targetLocation ? getLocationCoordinates(targetLocation.geoJson) : null

  if (!assetPosition || !targetPosition) {
    return null
  }

  return (
    <MapShape
      shape={window.google.maps.Polyline}
      parameters={{
        geodesic: false,
        path: [assetPosition, targetPosition],
        strokeColor: LINE_COLOR,
        // The line itself is hidden; the dash + arrow icons below render it as a dashed line
        // ending in an arrow at the target stop.
        strokeOpacity: 0,
        icons: [
          {
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              strokeColor: LINE_COLOR,
              scale: 3,
            },
            offset: '0',
            repeat: '14px',
          },
          {
            icon: {
              path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              fillColor: LINE_COLOR,
              fillOpacity: 1,
              strokeWeight: 0,
              scale: 3,
            },
            offset: '99.95%',
          },
        ],
      }}
    />
  )
}
